module.exports = __webpack_public_path__ + "img/Warehouse.5dfaa421.png";